export enum SSE_EVENT_TYPES {
  duplicateGroup = 'Group Copy-And-Paste',
  deleteGroup =  'Group Delete',
  duplicateSafetyModel = 'Safety Model Copy-And-Paste'
}